import React from 'react';
import { Helmet } from 'react-helmet';
import Button from '@material-ui/core/Button';
import GridContainer from '../../components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';

class NotFoundPage extends React.Component {
    goHome = () => {
        this.props.history.push('/');
    };

    render() {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Página no encontrada | Vivamos el Campo - Turismo Rural</title>
                </Helmet>

                <GridContainer justify="center" alignItems="center" style={{ minHeight: '80vh', textAlign: 'center' }}>
                    <GridItem xs={12} sm={12} md={12}>
                        <h1>Página no encontrada</h1>
                        <p>Lo sentimos, la página que buscas no existe</p>
                        <Button variant="contained" color="primary" onClick={this.goHome}>
                            Volver al inicio
                        </Button>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/views/NotFoundPage/NotFoundPage.js